"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var SwitchBase_1 = __importDefault(require("./SwitchBase"));
var SwitchIcon_1 = __importDefault(require("./SwitchIcon"));
var SwitchLabel_1 = __importDefault(require("./SwitchLabel"));
exports["default"] = Object.assign(SwitchBase_1["default"], {
    Label: SwitchLabel_1["default"],
    Icon: SwitchIcon_1["default"]
});
//# sourceMappingURL=index.js.map